import ReactDOM from "react-dom";
import React from "react";
import HexModal from "../../../app/components/modals/HexModal";
import DeliverBagToEmployeesModal from "./index";

export default function renderDeliverBagToEmployeesModal(props) {
  ReactDOM.render(
    <HexModal>
      <DeliverBagToEmployeesModal {...props} />
    </HexModal>,
    document.getElementById("modal-container")
  );
}
